import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import {
	DASHBOARD_EN,
	DASHBOARD_DE,
	NAVBAR_EN,
	NAVBAR_DE,
	LOGIN_EN,
	LOGIN_DE,
	LANG_EN,
	LANG_DE
} from '../locales'
import { ns, defaultNS } from './namespaces'

export const locales = {
	en: 'English'
	// de: 'Deutsch'
} as const

const resources = {
	en: {
		navbar: NAVBAR_EN,
		dashboard: DASHBOARD_EN,
		login: LOGIN_EN,
		all: LANG_EN
	},
	de: {
		navbar: NAVBAR_DE,
		dashboard: DASHBOARD_DE,
		login: LOGIN_DE,
		all: LANG_DE
	}
}

i18n.use(initReactI18next).init({
	resources,
	lng: 'en',
	defaultNS,
	ns,
	fallbackLng: 'en',
	interpolation: {
		escapeValue: false
	}
})

export default i18n
